import React from 'react';
import { InfoOutlinedIcon } from '../../../assets/mui';
import { PAYMENT_GATEWAY_IDFC, resolvePaymentGateway } from '../../../utils/pgInformation';
import { PgInformation } from '../../../hooks/useGetPgInformation';

interface AboutWalletProps {
  pgInformation?: PgInformation;
}

const AboutWallet: React.FC<AboutWalletProps> = ({ pgInformation }) => {
  const isIdfcGateway = resolvePaymentGateway(pgInformation) === PAYMENT_GATEWAY_IDFC;

  return (
    <div className="p-5 pb-3 mt-5" style={{ minWidth: '400px', maxWidth: '600px' }}>
      <h1 className="text-xl font-semibold text-slate-800">What happens after wallet recharge?</h1>
      <div className="flex gap-1 flex-col my-6">
        <p className="text-base text-gray-500 font-normal">
          After you recharge the wallet, the partner will be able to invest in upcoming deals. Add
          money to the wallet to proceed with wallet recharge.
        </p>
      </div>
      {!isIdfcGateway && (
        <div className="flex gap-2 items-center bg-[#f2901f14] rounded-lg px-3 py-4 w-full mb-8">
          <InfoOutlinedIcon className="text-[#D97706]" fontSize="small" />
          <span className="text-xs text-neutral-600">
            Transactions made via UPI will take{' '}
            <b className="text-stone-900">24-48 working hours</b> to reflect in your wallet. Recharge
            your wallet via <b className="text-stone-900">IMPS, NEFT or RTGS</b> to receive funds{' '}
            <b className="text-stone-900">faster.</b>
          </span>
        </div>
      )}
    </div>
  );
};

export default AboutWallet;
